import { atom } from "recoil";

const manualTypeAtom = atom({

    key:"manualType",
    default: ''

});

export default manualTypeAtom;